var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.imgUrl
      ? _c("img", {
          ref: "imgSty",
          staticClass: "iconClass",
          style: { width: _vm.width, height: _vm.height },
          attrs: { src: _vm.imgUrl, alt: "" }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }